module.exports = __webpack_public_path__ + "img/Cuba-logo1.9a002142.png";